export const examTrim = (text) => {
  if (text === undefined) return text;

  try {
    var resultText = [];
    var alignedText = text.split("\n");
    for (var i = 0; i < alignedText.length; i++) {
      resultText.push(" " + alignedText[i].trim());
    }
    resultText = resultText.join("\n");
    return resultText;
  } catch (err) {
    return text;
  }
};
